module.exports = __webpack_public_path__ + "static/img/pinpai-10.a3f33d8d.png";